<template>
  <div v-loading="initLoading">
    <iframe id="iframe" :src="'https://orangev.cn/dataanalysis/index/?idrt='+token" :height="height" width="100%"/>
  </div>
</template>

<script>

export default {
  name: "dataAnalysis",
  data (){
    return{
      initLoading: true,
    }
  },
  computed : {
    token(){
      let item = localStorage.getItem("token")
      item = item.substring(item.indexOf(".")+1,item.lastIndexOf("."))
      return item
    },
    height(){
      return window.innerHeight
    }
  },
  mounted () {
    let _this = this
    const iframe = document.querySelector('#iframe')
    // 处理兼容性问题
    if (iframe.attachEvent) {
      iframe.attachEvent('onload', function () {
        _this.initLoading = false
      })
    } else {
      iframe.onload = function () {
        _this.initLoading = false
      }
    }
  },

  created() {
    this.$store.commit('closeCollapse')
  }
}
</script>

<style scoped>
iframe {
  border: 0;
}
</style>
